import { Component, OnInit } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/angular';
import { EventCalendarService } from '../Services/event-calendar.service';
import { CalendarEvent } from '../Models/common.model';

@Component({
    selector: 'event-calendar',
    templateUrl: './event-calendar.component.html',
    styleUrls: [],
    providers: [EventCalendarService]
})

export class EventCalendarComponent implements OnInit {

    constructor(public dataService: EventCalendarService) {
    }

    EventList = [];
    
    ngOnInit(): void {
        this.dataService.getEvents().subscribe((data: CalendarEvent[]) => {
            this.calendarOptions.events = data;
        })

        this.dataService.getEvents().subscribe((data: CalendarEvent[]) => {
            const map = new Map();
            for (const item of data) {
                if (!map.has(item.type)) {
                    map.set(item.type, true);    // set any value to Map
                    this.EventList.push({
                        title: item.title,
                        type: item.type,
                        backgroundColor: item.backgroundColor,
                        start: item.start,
                        end: item.end,
                        isChecked: true
                    });
                }
            }
        })
    }

    calendarOptions: CalendarOptions = {
        timeZone: 'UTC',
        initialView: 'dayGridMonth',

        headerToolbar: {
            left: 'prev,next,today',
            center: 'title',
            right: 'dayGridMonth,dayGridWeek,dayGridDay,listMonth'
        },
        eventTimeFormat: { // like '14:30:00'
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            meridiem: false
        },

        eventClick: function (info) {
            if (info.event.url && info.event.url.length > 0) {
                info.jsEvent.preventDefault(); // don't let the browser navigate
                window.open(info.event.url, '_blank');
            }
        }
    };

    onCheckChange(changeEvent) {
        var selectedEvents: CalendarEvent[] = [];
        this.dataService.getEvents().subscribe((data: CalendarEvent[]) => {
            var uncheckedEv = this.EventList.filter((event) => { return event['isChecked'] == false })
            if (uncheckedEv.length > 0) {
                selectedEvents = data.filter((elem) => !uncheckedEv.find(({ type }) => elem.type === type));
                this.calendarOptions.events =selectedEvents;
            }
            else {
                this.calendarOptions.events = data;
            }
        })
    }
}